import styled from 'styled-components'
import { MEDIA } from 'src/utils/constants'
const { MOBILE_UP } = MEDIA

export const SuccessParagraph = styled.p`
  color: green;
  margin: 1rem;
  font-size: 1rem;
`

export const Footer = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-top: 5px;
  flex-direction: column;

  @media screen and ${MOBILE_UP} {
    justify-content: center;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`

export const Ball = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 64px;
  height: 4px;

  ${({ active }) => active
  ? 'background-color: var(--success);'
  : 'background-color: var(--bronze-gold);'
};
`

export const BallContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: -16px;
`

export const BallContent = styled.div`
  flex: 1;

  span {
    font-size: 10px;
    font-weight: 400;
    color: var(--gray-5);
  }
`
